import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
var styles = require('./SmtpAccountInformation.scss');
var SmtpAccountInformation = /** @class */ (function (_super) {
    tslib_1.__extends(SmtpAccountInformation, _super);
    function SmtpAccountInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onUseAltUsernamePasswordChecked = function (ev, checked) {
            _this.props.onUpdateUseAltUserNamePassword(checked);
        };
        return _this;
    }
    SmtpAccountInformation.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(Checkbox, { className: styles.checkbox, label: strings.options_connected_advanced_altUserNamePasswordCheckbox, defaultChecked: false, onChange: this.onUseAltUsernamePasswordChecked }),
            this.props.useAltUserNamePassword() && (React.createElement("div", null,
                React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_advanced_altUserNameTextField, onChanged: this.props.onUpdateSmtpUserName }),
                React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_advanced_altPasswordTextField, type: "password", onChanged: this.props.onUpdateSmtpPassword })))));
    };
    SmtpAccountInformation = tslib_1.__decorate([
        observer
    ], SmtpAccountInformation);
    return SmtpAccountInformation;
}(React.Component));
export default SmtpAccountInformation;
//# sourceMappingURL=SmtpAccountInformation.js.map